export default {"src":"/_next/static/media/Instagram.b36f633f.svg","height":32,"width":32};